import Vue from 'vue'
import Router from 'vue-router'
import settings from './modules/settings'
import business from './modules/business'
import service from './modules/service'
import Login from '@/views/Login'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/logout',
      name: 'logout',
      beforeEnter: function(to, from, next) {
        store.dispatch('auth/logout')

        next('/login')
      }
    },
    ...settings,
    ...business,
    ...service
  ]
})

const allowedRoutes = [
  'login',
  'logout'
]

router.beforeEach((to, from, next) => {
  if (allowedRoutes.indexOf(to.name) > -1) {
    next()
    return
  }

  if (!store.state.auth.authenticated) {
    next({ name: 'login' })
    return
  }

  if (to.path === '/') {
    // TODO check role before redirecting
    next({ name: 'yachts' })
    return
  }

  next()
})

export default router
